(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ── Quantity buttons ───────────────────────────────── */
  function initQtyButtons() {
    $$('.cv-qty-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(btn.dataset.index, 10);
        const change = parseInt(btn.dataset.change, 10);
        const input = btn.closest('.cv-qty-wrap').querySelector('.cv-qty-input');
        if (!input) return;
        const newQty = Math.max(0, parseInt(input.value, 10) + change);
        input.value = newQty;
        updateLineItem(index, newQty);
      });
    });
  }

  /* ── Remove buttons ─────────────────────────────────── */
  function initRemoveButtons() {
    $$('.cv-remove-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(btn.dataset.index, 10);
        updateLineItem(index, 0);
      });
    });
  }

  /* ── AJAX cart update ───────────────────────────────── */
  function updateLineItem(index, qty) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: index, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      if (qty === 0) {
        const row = $(`.cv-item[data-index="${index}"]`);
        if (row) row.remove();
        reindexItems();
        if (cart.item_count === 0) { location.reload(); return; }
      }
      updateTotals(cart);
      updateProgressBar(cart.total_price);
      updateCartCount(cart.item_count);
      setLoading(false);
    })
    .catch(() => { setLoading(false); location.reload(); });
  }

  function reindexItems() {
    $$('.cv-item').forEach((item, i) => {
      const idx = i + 1;
      item.dataset.index = idx;
      $$('[data-index]', item).forEach(el => el.dataset.index = idx);
    });
  }

  /* ── Update totals in summary ───────────────────────── */
  function updateTotals(cart) {
    const fmt = (c) => '₹' + (c / 100).toLocaleString('en-IN');

    const subtotal = $('.cv-summary-row span:last-child');
    if (subtotal) subtotal.textContent = fmt(cart.original_total_price);

    const total = $('.cv-summary-total span:last-child');
    if (total) total.textContent = fmt(cart.total_price);

    const stickyPrice = $('.cv-sticky-price');
    if (stickyPrice) stickyPrice.textContent = fmt(cart.total_price);

    // Update checkout button text
    const checkoutBtn = $('.cv-checkout-btn');
    if (checkoutBtn) {
      const svg = checkoutBtn.querySelector('svg');
      checkoutBtn.innerHTML = '';
      if (svg) checkoutBtn.appendChild(svg);
      checkoutBtn.insertAdjacentText('beforeend', ` Checkout securely · ${fmt(cart.total_price)}`);
    }

    const stickyBtn = $('.cv-sticky-btn');
    if (stickyBtn) stickyBtn.textContent = `Checkout · ${fmt(cart.total_price)} →`;
  }

  /* ── Update item count badge ────────────────────────── */
  function updateCartCount(count) {
    const countEl = $('.cv-cart-count');
    if (countEl) countEl.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;

    // Also update Dawn's header cart bubble
    $$('.cart-count-bubble span[aria-hidden]').forEach(el => el.textContent = count);
  }

  /* ── Progress bar ───────────────────────────────────── */
  function updateProgressBar(totalPrice) {
    const threshold = 49900;
    const remaining = threshold - totalPrice;
    const percent = Math.min(100, Math.round(totalPrice * 100 / threshold));
    const fill = $('.cv-progress-fill');
    const label = $('.cv-progress-label');
    if (fill) fill.style.width = percent + '%';
    if (label) {
      if (remaining <= 0) {
        label.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
        label.classList.add('cv-shipping-unlocked');
      } else {
        const fmt = (c) => '₹' + (c / 100).toLocaleString('en-IN');
        label.innerHTML = `Add <strong>${fmt(remaining)}</strong> more for <strong>free shipping</strong> 🚚`;
        label.classList.remove('cv-shipping-unlocked');
      }
    }
  }

  /* ── Loading state ──────────────────────────────────── */
  function setLoading(active) {
    const wrapper = $('#main-cart-items');
    if (wrapper) wrapper.style.opacity = active ? '0.5' : '1';
  }

  /* ── Upsell add to cart ─────────────────────────────── */
  function initUpsellButtons() {
    $$('.cv-upsell-add-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = btn.dataset.productId;
        if (!variantId) return;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Added';
          btn.style.background = '#16a34a';
          setTimeout(() => location.reload(), 700);
        })
        .catch(() => { btn.textContent = '+ Add'; });
      });
    });
  }

  /* ── Coupon toggle ──────────────────────────────────── */
  function initCouponToggle() {
    const toggle = $('#cv-coupon-toggle');
    const field = $('#cv-coupon-field');
    if (!toggle || !field) return;
    toggle.addEventListener('click', () => {
      const open = field.style.display !== 'none';
      field.style.display = open ? 'none' : 'block';
      if (!open) setTimeout(() => { const inp = $('#cv-discount-input'); if (inp) inp.focus(); }, 50);
    });
    const applyBtn = $('#cv-coupon-apply');
    const discountInput = $('#cv-discount-input');
    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', () => {
        const code = discountInput.value.trim();
        if (code) window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
      });
      discountInput.addEventListener('keydown', e => { if (e.key === 'Enter') applyBtn.click(); });
    }
  }

  /* ── Sticky bar ─────────────────────────────────────── */
  function initStickyBar() {
    const bar = $('#cv-sticky-checkout');
    if (!bar) return;
    const checkoutBtn = $('.cv-checkout-btn');
    function update() {
      if (!checkoutBtn) { bar.style.display = 'block'; return; }
      bar.style.display = checkoutBtn.getBoundingClientRect().bottom < 0 ? 'block' : 'none';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Boot ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initQtyButtons();
    initRemoveButtons();
    initUpsellButtons();
    initCouponToggle();
    initStickyBar();
  });

})();
document.addEventListener('DOMContentLoaded', () => {
  const checkoutBtn = document.querySelector('.cv-checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      window.location.href = '/checkout';
    });
  }
});